// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-checkbox-wrapper {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin-right: 2rem;
}

.custom-checkbox-input {
  display: none;
}

.custom-checkbox-box {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 2px solid #666;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  transition: all 0.2s ease;
}

.custom-checkbox-box.checked {
  border-color: transparent;
}

.custom-checkbox-check {
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 2px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.rbc-event-content {
	color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/styles/CalendarsDisplay.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;CACC,kBAAkB;AACnB","sourcesContent":[".custom-checkbox-wrapper {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  margin-right: 2rem;\n}\n\n.custom-checkbox-input {\n  display: none;\n}\n\n.custom-checkbox-box {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  border: 2px solid #666;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 6px;\n  transition: all 0.2s ease;\n}\n\n.custom-checkbox-box.checked {\n  border-color: transparent;\n}\n\n.custom-checkbox-check {\n  width: 10px;\n  height: 10px;\n  background-color: white;\n  border-radius: 2px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.rbc-event-content {\n\tcolor: transparent;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
